import React from 'react';
import { ProfileRecordStatus } from '@nkr/enums/profile-record-status';
import { Button, Panel } from 'react-bootstrap';
import { IDetailData } from '../../detail-data';
import { useFormContext } from 'react-hook-form';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { toast } from 'react-toastify';
import useTransferPatient from '@nkr/store/recipient/hooks/transfer-patient-hook';

interface IProps {
    onUpdate: (approved: boolean) => void
}

const CompleteTransferRequest = ({ onUpdate }: IProps) => {
    const { app: { center } } = useAppHookContext();
    const { watch } = useFormContext<IDetailData>();

    const { approveTransfer, declineTransfer } = useTransferPatient();

    const data = watch();

    const handleDecision = (approved: boolean) => {
        if (approved) {
            approveTransfer(data.transferRequest.id).then(response => {
                if (response.data.success) {
                    toast.success('Patient transferred successfully');
                    onUpdate(approved);
                }
            });
        } else {
            declineTransfer(data.transferRequest.id).then(response => {
                if (response.data.success) {
                    toast.info('Patient returned to original center');
                    onUpdate(approved);
                }
            });
        }
    };

    return (
        <Panel bsStyle='primary'>
            <Panel.Heading>TRANSFER REQUEST</Panel.Heading>
            <Panel.Body>
                <div style={{ marginBottom: 10 }}>
                    A patient intake transfer request has been initiated for <strong>{data.firstName.toUpperCase()} {data.lastName.toUpperCase()}</strong> from <strong>{data.transferRequest.currentCenterAlias}</strong>
                </div>

                <table>
                    <tbody>
                        <tr>
                            <td style={{ paddingRight: 20 }}>DOB:</td>
                            <td>{data.birthDate}</td>
                        </tr>
                        <tr>
                            <td style={{ paddingRight: 20 }}>Existing Recipient Profile:</td>
                            <td>{data.recipientRecordStatus != ProfileRecordStatus.NonExistent ? 'YES' : 'No'}</td>
                        </tr>
                        {center.isMicrositeParticipant && (
                            <tr>
                                <td style={{ paddingRight: 20 }}>Existing Microsite:</td>
                                <td>{data.micrositeRecordStatus != ProfileRecordStatus.NonExistent ? 'YES' : 'No'}</td>
                            </tr>
                        )}
                    </tbody>
                </table>

                <div style={{ marginTop: 10, marginBottom: 20 }}>Please review the patient information below and approve or decline the transfer to assume active lifecycle management of this profile.</div>
                
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button bsStyle='primary' bsSize='sm' onClick={() => handleDecision(true)}>Approve Transfer</Button>&nbsp;
                    <Button bsSize='sm' onClick={() => handleDecision(false)}>Decline Transfer</Button>
                </div>
            </Panel.Body>
        </Panel>
    );
}

export default CompleteTransferRequest;